import { createSlice,PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../store';

export const name = 'rfxResponseUI';

export interface ResponseUIProps {
  documentStep: {
    showQuoteValidityModal: boolean;
  };
}

const initialState: ResponseUIProps = {
  documentStep: {
    showQuoteValidityModal: false
  }
};

const rfxResponseUISlice = createSlice({
  name,
  initialState,
  reducers: {
    setShowQuoteValidityModal(state, action: PayloadAction<boolean>) {
      state.documentStep.showQuoteValidityModal = action.payload;
    }
  }
});

export const { setShowQuoteValidityModal } = rfxResponseUISlice.actions;

export const selectShowQuoteValidityModal = (state: RootState): boolean => {
  return state.rfxResponseUI.documentStep.showQuoteValidityModal;
};

export default rfxResponseUISlice.reducer;
